import React from 'react';
import FarmerPage from './FarmerPage';

const FarmerDatabasePage = () => {
  return <FarmerPage useApi={true} />;
};

export default FarmerDatabasePage;





